module.exports = __webpack_public_path__ + "img/b.c1e57689.jpg";